import NP from "../1. Core/NP";
import LoginPanel from "../1. Core/Intro/LoginPanel";

NP.showAuth = function ()
{
	new LoginPanel({
		ParentNode: document.body,
		ReturnURL: NP.getQueryParam("rurl")
	});
};
